<script>
  export let url
  export let cta
</script>
<!-- Attribution -->
<p
  data-field-label="Attribution"
  class="label | text-right">
  {#if url.length > 0 }
    <a href="{url}">
      {cta}
    </a>
  {:else}
    {cta}
  {/if}
</p>